import React from "react";
import { motion } from "framer-motion";
// import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Loader from "./Loader";
import "../styles/loader.css";
import "../styles/homepage.css";
import Contact from "./Contact";
import InsideHome from "./InsideHome";
import DSCLead from "./DSCLead";

const Home = () => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setLoaded(true);
    }, 7600);
  }, []);
  return (
    <motion.div
      className="container"
      // initial="rest"
      // whileHover="hover"
      // animate="rest"
    >
      <div className="first-wrapper h-max flex flex-col items-center justify-center ">
        <motion.div className="home-content first flex flex-col text-center w-full pt-28">
          <h1 className="sm:text-3xl lg:text-5xl text-3xl font-semibold mb-5 text-gray-700 dark:text-gray-200">
            DSC AISSMSCOE
          </h1>
          <div className="mt-10">
            <Loader loaded={loaded} />
            <div className="p-3 w-8/12 font-medium text-center text-xl md:text-2xl text-gray-600 dark:text-gray-300 relative m-auto mb-8 mt-2">
              Our vision at DSC AISSMS COE is to forge great designers,
              developers and managers by working on projects and bind them
              together to shape our society
              <br />
              <b>
                "Alone we can do so little, together we can do so much." --Helen
                Keller
              </b>
            </div>
          </div>
        </motion.div>
      </div>
      <DSCLead />
      <InsideHome />
      <Contact />
    </motion.div>
  );
};

export default Home;
